import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isTokenExpired } from "../utils/helpers";
import { refreshToken, handleTokenRefreshFailure } from "../components/auth/tokenRefreshService";
import { AuthCommandFacade } from "../components/auth/AuthCommandFacade";

const useTokenExpiryCheck = () => {
  const navigate = useHistory();
  const dispatch = useDispatch();
  const lang = useSelector((state) =>
    state.ui ? state.ui.lang : localStorage.BLLANG,
  );

  const auth = new AuthCommandFacade(dispatch, navigate, lang);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiryTime = payload.exp * 1000;
    const currentTime = Date.now();
    const buffer = 60000;
    const delay = Math.max(0, expiryTime - currentTime - buffer);
    let timeoutId;

    const checkAndRefreshToken = async () => {
      const currentToken = localStorage.getItem("token");
      if (currentToken && isTokenExpired(currentToken)) {
        const newToken = await refreshToken();
        if (!newToken) {
          auth.logout();
          handleTokenRefreshFailure();
        }
      }
    };

    timeoutId = setTimeout(checkAndRefreshToken, delay);
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkAndRefreshToken();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch, navigate]);
};

export default useTokenExpiryCheck;
